import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, IconButton, Typography, useMediaQuery, useTheme, Stack, Badge } from '@mui/material';
import AppsOutageIcon from '@mui/icons-material/AppsOutage';
import useUsers from '../../context/UsersContext';
import usePages from '../../context/PageContext';
import { getIcon } from '../../utils/helper';
import simpletaskService from '../../service/simpletask.service';
import { sxConfig } from './operationWidget4.style';
import useParam from '../../context/ParamContext';

export const Widget4Page = () => {
  const { getUser, user } = useUsers();
  const { getParam, params } = useParam();
  const { setPages } = usePages();

  const navigate = useNavigate();
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up('md'));

  const [todoCount, setTodoCount] = useState(null);

  useEffect(() => {
    if (!Object.keys(user).length) getUser();
    if (!Object.keys(params).length) getParam();
    getMyTodoCount();
  }, []);

  const getMyTodoCount = () => {
    simpletaskService.getMyTodoCount().then((data) => {
      setTodoCount(data.count);
    });
  };

  const handleNavigate = (data) => {
    navigate(`/app/${data.subMenuUrl}`);
    setPages({ subMenuName: data.name });
  };

  const favouriteMenus = user?.favouriteMenu
    ?.filter((favouriteMenu) => favouriteMenu.showOnHomePage && (isLgUp || favouriteMenu.showOnPhone))
    ?.sort((a, b) => (isLgUp ? a.visOrder - b.visOrder : a.phoneVisOrder - b.phoneVisOrder));

  return (
    <Box sx={sxConfig.page}>
      <Grid
        container
        spacing={{
          xs: 1.5,
          md: 2.5,
        }}
        justifyContent="center"
      >
        {params.SHOW_HOMEPAGE_MYTODO_CARD === 'Y' && (
          <Grid item sx={sxConfig.cardGridItem}>
            <Box
              onClick={() => handleNavigate({ subMenuUrl: 'mytodo', name: 'Teendőim' })}
              sx={{
                height: {
                  xs: 90,
                  md: 200,
                },
                ...sxConfig.card,
              }}
            >
              <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                <Stack direction="row" spacing={2} alignItems="center">
                  <AppsOutageIcon sx={sxConfig.todoIcon} />
                  <Typography fontWeight={700} sx={sxConfig.todoTitle}>
                    Teendőim
                  </Typography>
                </Stack>

                <Box sx={sxConfig.todoCountBadge}>{todoCount}</Box>
              </Stack>
            </Box>
          </Grid>
        )}
        {favouriteMenus?.map((favouriteMenu) => (
          <Grid
            item
            key={favouriteMenu.id}
            sx={{
              ...sxConfig.cardGridItem,
              width: {
                ...sxConfig.cardGridItem.width,
                xs: '50%',
              },
              flexBasis: {
                ...sxConfig.cardGridItem.flexBasis,
                xs: '50%',
              },
              maxWidth: {
                ...sxConfig.cardGridItem.maxWidth,
                xs: '50%',
              },
            }}
          >
            <Box
              onClick={() => handleNavigate(favouriteMenu)}
              sx={{
                height: {
                  xs: 130,
                  md: 200,
                },
                ...sxConfig.card,
              }}
            >
              <Typography component="div" sx={sxConfig.menuTitle}>
                {favouriteMenu.name}
              </Typography>

              <IconButton disableRipple tabIndex={-1} sx={sxConfig.menuIconButton}>
                {getIcon(favouriteMenu.icon, isLgUp ? '3rem' : '2.5rem', isLgUp ? '#16a34a' : '#0fbd1d')}
              </IconButton>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
